import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivityReopened = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.58953 12.7401L5.76953 9.90008L8.60953 7.08008",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3904 22.1304C17.3219 22.1304 22.1304 17.3219 22.1304 11.3904C22.1304 5.45885 17.3219 0.650391 11.3904 0.650391C5.45885 0.650391 0.650391 5.45885 0.650391 11.3904C0.650391 17.3219 5.45885 22.1304 11.3904 22.1304Z",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.76953 9.91016H14.2295C16.0295 9.91016 17.4995 11.2202 17.4995 12.8402C17.4995 14.4602 16.0395 15.7702 14.2295 15.7702H5.76953",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgActivityReopened;
